// =============================================================================
//          (c) Copyright 2021 by Brinks Home Security | Dallas, TX, USA
// =============================================================================
// Version   : 0.1.1
// Created at: 08.24.16
// Project   : Brinks Home Security Shared Assets
// -----------------------------------------------------------------------------
// Utilities for responsive javascript
// - Like media queries for CSS, these let you run javascript only at certain
//   viewport widths.
// - Uses the Bootstrap breakpoints used by our CSS.
//
// TODO: Real-time breakpoint tracking. Need some sort of breakpoint change
// listener so code that uses these utilities can rerun if necessary.
// -----------------------------------------------------------------------------

import '../shims/array.includes'

const Breakpoints = (() => {
  const Points = ['xs', 'sm', 'md', 'lg', 'xl']
  const RangeModifiers = {
    UP: 'up',
    DOWN: 'down'
  }

  /* --------------------------------------------------------------------------
    Private
  -------------------------------------------------------------------------- */

  function bpIndex (bp) {
    if (Points.includes(bp)) {
      return Points.indexOf(bp)
    }

    return false
  }

  // The current Bootstrap breakpoint is stored in the `content` property of
  // the HTML element's before pseudo-element. As such, cant use jQuery.
  function getCurrentBp () {
    let pseudoEl = window.getComputedStyle(document.documentElement, ':after')
    return pseudoEl.getPropertyValue('content').replace(/['"]/g, '')
  }

  // Check if the breakpoint code includes a valid range modifier
  function isRange (bp = '') {
    let modifier = bp.split('-')[1]

    return modifier === RangeModifiers.UP ||
           modifier === RangeModifiers.DOWN
  }

  function isCurrentInRange (bp) {
    const rangeBase = bp.split('-')[0]
    const rangeModifier = bp.split('-')[1]

    switch (rangeModifier) {
      case RangeModifiers.UP:
        return bpIndex(getCurrentBp()) >= bpIndex(rangeBase)
      case RangeModifiers.DOWN:
        return bpIndex(getCurrentBp()) <= bpIndex(rangeBase)
      default:
        return false
    }
  }

  /* --------------------------------------------------------------------------
    Public
  -------------------------------------------------------------------------- */

  let Breakpoints = {
    /**
     * Check to see if the current Bootstrap breakpoint matches a given
     * breakpoint, or if the current breakpoint is within a given range.
     *
     * @param {String} bp A Bootstrap breakpoint code. Can be specific (i.e
     * 'xs') or a range (i.e. 'md-down').
     * @returns {Boolean} isMatch – true if the current breakpoint matches,
     * false if not.
     */
    is (bp) {
      if (isRange(bp)) {
        return isCurrentInRange(bp)
      }

      return bp === getCurrentBp()
    },

    current () {
      return getCurrentBp()
    }
  }

  return Breakpoints
})(jQuery)

export default Breakpoints
